import React, { useEffect } from 'react';
import { Layout, Card, Typography } from 'antd';
import { EmailForm } from 'client-app/components/login/email-form';
import styles from './login.module.scss';

export const Login: React.FC = () => {
  useEffect(() => {
    document.title = 'Tankel Sign In';
  }, []);

  return (
    <Layout className={styles.main}>
      <Card className={styles.card}>
        <img src='/tankel.png' alt='Tankel Logistics' width={110} />
        <Typography.Title level={4}>Sign in</Typography.Title>
        <EmailForm />
      </Card>
    </Layout>
  );
};
